import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Twitter, Mail, MapPin, Phone, Download } from "lucide-react";
import { COMPANY } from "../lib/content";

export default function Footer() {
  return (
    <footer className="bg-[#0A1F3F] text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white text-[#0A1F3F] flex items-center justify-center font-display font-black text-lg border-b-4 border-[#F37021]">
                B
              </div>
              <div>
                <div className="font-display font-black tracking-tight text-xl">BNM GROUP</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/70 mt-1">
                  {COMPANY.tagline}
                </div>
              </div>
            </div>
            <div className="font-display font-black text-3xl sm:text-4xl tracking-tighter leading-[1.05] mb-6">
              Connecting industries,
              <br />
              markets &amp; <span className="text-[#F37021]">opportunities.</span>
            </div>
            <p className="text-[#A9B4C8] max-w-md leading-relaxed">
              {COMPANY.description}
            </p>

            <Link
              to="/company-profile"
              data-testid="footer-download-profile"
              className="mt-8 inline-flex items-center gap-3 bg-[#F37021] hover:bg-[#D35F16] text-white px-6 py-4 text-xs uppercase tracking-[0.18em] font-semibold transition-colors"
            >
              <Download className="w-4 h-4" />
              Download Company Profile
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="text-eyebrow text-[#A9B4C8] mb-5">Explore</div>
            <ul className="space-y-3 text-sm">
              {[
                ["Industries", "/industries"],
                ["Products", "/products"],
                ["Markets", "/markets"],
                ["Blog", "/blog"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="inline-flex items-center gap-2 hover:text-[#F37021] transition-colors"
                  >
                    {label} <ArrowUpRight className="w-3 h-3" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-eyebrow text-[#A9B4C8] mb-5">Contact</div>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#F37021] shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone className="w-4 h-4 mt-1 text-[#F37021] shrink-0" />
                <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-[#F37021]">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex gap-3">
                <Mail className="w-4 h-4 mt-1 text-[#F37021] shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#F37021]">
                  {COMPANY.email}
                </a>
              </li>
            </ul>

            <div className="flex gap-3 mt-8">
              <a
                href="#"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
                className="w-10 h-10 border border-[#1E3966] flex items-center justify-center hover:bg-[#F37021] hover:border-[#F37021] transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="#"
                data-testid="social-twitter"
                aria-label="Twitter"
                className="w-10 h-10 border border-[#1E3966] flex items-center justify-center hover:bg-[#F37021] hover:border-[#F37021] transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1E3966] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#A9B4C8]">
            © {new Date().getFullYear()} BNM Group. All rights reserved.
          </p>
          <p className="text-xs text-[#A9B4C8] uppercase tracking-[0.22em]">
            Ankara · Dubai · Almaty · Lagos
          </p>
        </div>
      </div>
    </footer>
  );
}
